/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GdprInputs */

const cs_nav_gdpr = /** @type {(inputs: Nav_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

const en_nav_gdpr = /** @type {(inputs: Nav_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GDPR`)
};

/**
* | output |
* | --- |
* | "GDPR" |
*
* @param {Nav_GdprInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_gdpr = /** @type {((inputs?: Nav_GdprInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GdprInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_gdpr(inputs)
	return cs_nav_gdpr(inputs)
});